import script from "./bonusomat-automat-cylinder.vue?vue&type=script&setup=true&lang=ts"
export * from "./bonusomat-automat-cylinder.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__